<template>
	<svg
		fill="#000000"
		height="64px"
		width="64px"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 470 470"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		enable-background="new 0 0 470 470"
	>
		<g id="SVGRepo_bgCarrier" stroke-width="0" />

		<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

		<g id="SVGRepo_iconCarrier">
			<g>
				<circle cx="190.864" cy="62.046" r="7.5" />
				<path
					d="m99.366,119.48c-5.194-5.193-12.1-8.054-19.445-8.054s-14.251,2.86-19.445,8.054c-10.723,10.723-10.723,28.17 0,38.893 5.194,5.193 12.1,8.054 19.445,8.054s14.251-2.86 19.445-8.054c10.723-10.723 10.723-28.17 1.42109e-14-38.893zm-10.606,28.286c-2.361,2.361-5.5,3.661-8.839,3.661s-6.478-1.3-8.839-3.661c-4.874-4.874-4.874-12.804 0-17.678 2.361-2.36 5.5-3.661 8.839-3.661s6.478,1.301 8.839,3.661c4.874,4.874 4.874,12.804 0,17.678z"
				/>
				<path
					d="M15,194.432C15,95.493,95.493,15,194.432,15c49.532,0,95.646,19.744,129.848,55.596c2.859,2.998,7.607,3.11,10.604,0.25 c2.997-2.859,3.109-7.606,0.25-10.604c-17.968-18.835-39.121-33.65-62.871-44.036C247.672,5.452,221.486,0,194.432,0 C87.222,0,0,87.222,0,194.432c0,27.054,5.453,53.24,16.206,77.831c10.386,23.75,25.202,44.903,44.037,62.871 c1.452,1.386,3.315,2.073,5.176,2.073c1.979,0,3.954-0.778,5.428-2.323c2.859-2.997,2.747-7.744-0.25-10.604 C34.745,290.078,15,243.964,15,194.432z"
				/>
				<circle cx="230.5" cy="203.182" r="7.5" />
				<circle cx="292.876" cy="297.5" r="7.5" />
				<path
					d="m357.876,203.182c0-26.191-21.309-47.5-47.5-47.5s-47.5,21.309-47.5,47.5 21.309,47.5 47.5,47.5 47.5-21.309 47.5-47.5zm-47.5,32.5c-17.921,0-32.5-14.579-32.5-32.5s14.579-32.5 32.5-32.5 32.5,14.579 32.5,32.5-14.579,32.5-32.5,32.5z"
				/>
				<path
					d="m220.558,300.453c-26.191,0-47.5,21.309-47.5,47.5s21.309,47.5 47.5,47.5 47.5-21.309 47.5-47.5-21.309-47.5-47.5-47.5zm0,80c-17.92,0-32.5-14.579-32.5-32.5s14.58-32.5 32.5-32.5c17.921,0 32.5,14.579 32.5,32.5s-14.579,32.5-32.5,32.5z"
				/>
				<path
					d="m344.146,329.979c-15.163,0-27.5,12.337-27.5,27.5s12.337,27.5 27.5,27.5 27.5-12.337 27.5-27.5-12.337-27.5-27.5-27.5zm0,40c-6.893,0-12.5-5.607-12.5-12.5s5.607-12.5 12.5-12.5 12.5,5.607 12.5,12.5-5.608,12.5-12.5,12.5z"
				/>
				<path
					d="m390.146,258.67c-15.163,0-27.5,12.337-27.5,27.5s12.337,27.5 27.5,27.5 27.5-12.337 27.5-27.5-12.337-27.5-27.5-27.5zm0,40c-6.893,0-12.5-5.607-12.5-12.5s5.607-12.5 12.5-12.5 12.5,5.607 12.5,12.5-5.608,12.5-12.5,12.5z"
				/>
				<path
					d="m188.49,232.479c0-15.163-12.336-27.5-27.5-27.5s-27.5,12.337-27.5,27.5 12.336,27.5 27.5,27.5 27.5-12.336 27.5-27.5zm-27.5,12.5c-6.893,0-12.5-5.607-12.5-12.5s5.607-12.5 12.5-12.5 12.5,5.607 12.5,12.5-5.608,12.5-12.5,12.5z"
				/>
				<path
					d="M275.567,81.136c-107.21,0-194.432,87.222-194.432,194.432C81.136,382.778,168.357,470,275.567,470 C382.778,470,470,382.778,470,275.567C470,168.357,382.778,81.136,275.567,81.136z M275.567,455 c-98.939,0-179.432-80.493-179.432-179.433c0-98.938,80.493-179.432,179.432-179.432C374.507,96.136,455,176.629,455,275.567 C455,374.507,374.507,455,275.567,455z"
				/>
			</g>
		</g>
	</svg>
</template>
